import type { Variants } from "framer-motion";
import { Building2, Layers, ShieldCheck, Sparkles, Wind, type LucideIcon } from "lucide-react";

export const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.15,
    },
  },
  exit: {},
};

export const itemVariants: Variants = {
  hidden: { opacity: 0, x: -14 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.28, ease: "easeOut" },
  },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};

export const subItemVariants: Variants = {
  hidden: { opacity: 0, x: -10 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.22, ease: "easeOut" },
  },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};

export const subContainerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.06 },
  },
  exit: {},
};

export type ServiceItem = {
  icon: LucideIcon;
  label: string;
  path: string;
};

export const serviceItems: ServiceItem[] = [
  { icon: Sparkles, label: "General Cleaning",  path: "/services/classic-cleaning" },
  { icon: Wind,     label: "Aircon Servicing",  path: "/services/aircon-servicing"  },
  { icon: Layers,   label: "Deep Cleaning",     path: "/services/deep-cleaning"     },
  { icon: ShieldCheck, label: "Disinfection",   path: "/services/disinfection"      },
  { icon: Building2,   label: "Office Cleaning",path: "/services/office-cleaning"   },
];
